<template>
    <svg width="200" height="8" class="dropper" :style="style">
        <circle cx="4" cy="4" r="4" fill="firebrick" />
        <rect x="4" y="3" width="200" height="2" fill="firebrick" />
    </svg>
</template>

<script>
export default {
    props: {
        position: { }
    },
    computed: {
        style() {
            let properties = {};

            if (this.position != null) {
                let x = this.position[0] - 4;
                let y = this.position[1] - 4;

                properties.transform = `translate(${x}px, ${y}px)`;
            } else {
                properties.display = "none";
            }

            return properties;
        }
    }
}
</script>

<style lang="less" scoped>
.dropper
{
    display: inline-block;
    position: absolute;
    left: 0;
    top: 0;
    margin: 0;
    padding: 0;
    pointer-events: none;
}
</style>
